import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {CONFIG} from "../../../app/config";
import {TFieldType, TStatusBar, Util} from "../../../app/util";
import {
    TAction,
    TBlendedMove,
    TBlendedTipo,
    TProdutoTipo,
    TProductUnid,
    TProdutoAuth,
    TZiptipo,
    TImageModel,
    ENUM,
} from "../../../app/enum";
import {WebstorService} from "../../../providers/webstor-service";
import {LogadoService} from "../../../providers/logado-service";
import {ModalActionPage} from "../modal-action/modal-action";
import {ModalFieldPage} from "../modal-field/modal-field";
import {WebstorOpenPage} from "../webstor-open/webstor-open";


@Component({
    selector: 'page-blended-menu',
    templateUrl: 'blended-menu.html',
    providers: [WebstorService]
})

export class BlendedMenuPage {

    TFieldType: any = TFieldType;
    TImageModel: any = TImageModel;
    TBlendedTipo: any = TBlendedTipo;
    TBlendedMove: any = TBlendedMove;
    TProdutoTipo: any = TProdutoTipo;
    TProductUnid: any = TProductUnid;
    TProdutoAuth: any = TProdutoAuth;

    config: any;
    logado: any;

    etapa: number;
    mlist: TImageModel;

    branded: any;
    indexBL: number;
    indexBX: number;
    boxroot: any;

    logoerro: Array<boolean> = [false, false, false, false];

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public util: Util,
                public logadoService: LogadoService, public webstorService: WebstorService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.etapa = this.navParams.get('etapa');
        this.mlist = this.navParams.get('mlist');

        this.branded = this.navParams.get('branded');
        this.indexBL = this.navParams.get('indexBL');
        this.indexBX = this.navParams.get('indexBX');

        if (this.etapa == 2) this.boxroot = this.branded.Blendeds[this.indexBL].Produtos[this.indexBX];

        this.blendedLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    blendedLoad() {

        if (this.etapa == 1) return;
        if (this.etapa == 2) return;

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.blended(TAction.acSafe, this.branded.BrandedID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.branded.Blendeds = data.Blendeds,
                erro => this.util.alertResult(erro, () => this.dismiss())
            )

    }

    getTitle() {

        if (this.etapa == 0) return this.branded.BrandedNome;
        if (this.etapa == 1) return this.branded.Blendeds[this.indexBL].BlendedNome;
        if (this.etapa == 2) return this.branded.Blendeds[this.indexBL].Produtos[this.indexBX].ProdutoNome;

    }



    /** ************************************************* GENERIC ************************************************* **/
    /** ************************************************* etapa-X ************************************************* **/

    logoerror(pos: number, event?) {

        this.logoerro[pos] = true;
        event.parentElement.removeChild(event);

    }

    logocheck(pos: number, keyname: string, invert: boolean): boolean {

        if (this.etapa == 1) {
            if (!invert) return (this.branded.Blendeds[this.indexBL][keyname] && !this.logoerro[pos]);
            if (invert)  return (!this.branded.Blendeds[this.indexBL][keyname] || this.logoerro[pos]);
        }

        if (this.etapa == 2) {
            if (!invert) return (this.boxroot[keyname] && !this.logoerro[pos]);
            if (invert)  return (!this.boxroot[keyname] || this.logoerro[pos]);
        }

    }

    logoclick(field: any) {

        let logosize = (field == 'BrandedBase' || field == 'BrandedLogo' ? 1024 : 250);
        let logobyte = (field == 'BrandedBase' || field == 'BrandedSymb' ? (200 * 1024) : (650 * 1024));
        let options = {acceptTypes: 'image/png', sizebyte: logobyte, selectLimit: 0, minmax: 'FIX', width: logosize, height: logosize, quality: 100};
        this.util.fileSelect(options).subscribe(
            base => {

                this.util.pngTransparent(base[0].base64)
                    .subscribe(
                        data => {
                            let fie64 = field + '64';
                            this.branded.Blendeds[this.indexBL][fie64] = base[0].base64.split(',')[1];
                            this.branded.Blendeds[this.indexBL][field] = base[0].base64;
                            this.blendedSave(null);
                        },
                        erro => this.util.alertSimply('PNG não é transparente!')
                    );

            },

            erro => this.util.alertResult(erro)
        );

    }

    moduledText(fieldName, fieldType: TFieldType) {

        let blended = this.branded.Blendeds[this.indexBL];
        let keyroot = (this.etapa == 1 ? blended : this.boxroot);

        let onOkiy = (that, okiy, index, isLast) => {

            if (this.etapa == 1) {
                keyroot[fieldName] = okiy[0].groups[0].fields[0].value;
                this.blendedSave(that);
            }

            if (this.etapa == 2) {
                keyroot[fieldName] = okiy[0].groups[0].fields[0].value;
                this.produtoSave(that);
            }

        };

        let fieldHtml = this.config.modalField(fieldType, null, null, null, keyroot[fieldName], null, null);
        let groupHtml = this.config.modalGroup(null, [fieldHtml]);
        let slideHtml = this.config.modalSlide('Texto', null, null, null, 'CorRoxa', [groupHtml]);

        this.util.modalopen(ModalFieldPage, 'quad', false, {slides: [slideHtml], onOkiy: onOkiy}).subscribe();

    }



    /** ************************************************* BLENDED ************************************************* **/
    /** ************************************************* etapa-1 ************************************************* **/

    blendedMenu(blended) {

        let indexBL = this.branded.Blendeds.indexOf(blended);
        let object = {etapa: 1, branded: this.branded, indexBL: indexBL};
        this.navCtrl.push(BlendedMenuPage, object);

    }

    blendedCria(tipo: TBlendedTipo) {

        let object = {etapa: 1, branded: this.branded, blendTipo: tipo, blendNovo: true};
        this.util.modalopen(BlendedMenuPage, 'alto', false, object).subscribe();

    }

    blendedSave(that, send?) {

        //Criando novo registro...
        if (!this.branded.Blendeds[this.indexBL].BlendedID && !send) {
            if (that) that.dismiss();
            return;
        }


        //Criando ou Editando...
        let loading = this.util.loadingDots();
        loading.present();

        let blended = this.branded.Blendeds[this.indexBL];
        this.webstorService.blended(TAction.acSave, this.branded.BrandedID, TBlendedTipo.btNone, blended)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (!blended.BlendedID) blended.BlendedID = data.Codigo;
                    if (that) that.dismiss(blended);

                },
                erro => this.util.alertResult(erro)
            );

    }

    blendedMove() {

        let onSave = (move) => {
            this.branded.Blendeds[this.indexBL].BlendedMove = move;
            this.blendedSave(null);
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TBlendedMove);
        let buttons: Array<any> = [];
        arrayEnum.forEach(move => buttons.push({text: move.slice(2, 99), handler: () => onSave(TBlendedMove[move])}));
        this.util.sheetOpen(buttons, 'STOCK');

    }

    justifyMenu() {

        let onJust = (data) => {

        };

        let title = this.branded.Blendeds[this.indexBL].BlendedNome;
        let object = {homeb: false, etapa: 0, title: title, keyname: 'Justify', toggler: 'ball'};
        this.util.modalopen(WebstorOpenPage, 'quad', true, object).subscribe(data => onJust(data));

    }

    blendedZipe(field) {

        let name = field.substr(7, 4);
        let tipo = TZiptipo['zp' + name];
        let mask = ENUM.ziptipoMask(tipo);

        let onOkey = (okey, that, data) => {

            let onCity = (city) => {
                if (city.Ziploads.length == 0) {
                    this.util.alertSimply('Código inexistente.', 'ERRO', 'OK', true);
                    return;
                }
                this.branded.Blendeds[this.indexBL][field] = okey.inputf.text;
                this.blendedSave(that);
            };

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.zipload(TAction.acLoad, tipo, okey.inputf.text)
                .finally(() => loading.dismiss()).subscribe(
                    data => onCity(data),
                    erro => this.util.alertResult(erro)
            );

        };

        let data = {name: name.toUpperCase(), mask: mask, size: mask.length};
        let objectData = {modalinfo: this.config.modalinfo(this.util, 'fiscal', onOkey, null, false, data)};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    blendedComb() {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Nome', handler: () => this.moduledText('BlendedNome', TFieldType.ftLine)});
        buttons.push({text: 'Tipo', handler: () => this.blendedTipo()});
        this.util.sheetOpen(buttons, 'SETTING');

    }

    blendedIcon() {

        if (this.branded.Blendeds[this.indexBL].BlendedTipo == TBlendedTipo.btProduto) return 'b-icon-beer-1';
        if (this.branded.Blendeds[this.indexBL].BlendedTipo == TBlendedTipo.btServico) return 'b-icon-tools';
        if (this.branded.Blendeds[this.indexBL].BlendedTipo == TBlendedTipo.btConvite) return 'b-icon-ticket';
        if (this.branded.Blendeds[this.indexBL].BlendedTipo == TBlendedTipo.btCertify) return 'b-icon-certificate';

        return '';

    }

    blendedTipo() {

        let onSave = (tipo) => {
            this.branded.Blendeds[this.indexBL].BlendedTipo = tipo;
            this.produtoSave(null);
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TBlendedTipo);
        let buttons: Array<any> = [];
        arrayEnum.forEach(tipo => buttons.push({text: tipo.slice(2, 99), handler: () => onSave(TBlendedTipo[tipo])}));
        this.util.sheetOpen(buttons, 'TIPO');

    }

    clusterMenu() {

    }

    pictureMenu() {

    }

    meritumMenu() {

    }

    stationMenu() {

    }



    /** ************************************************* PRODUTO ************************************************* **/
    /** ************************************************* etapa-2 ************************************************* **/

    produtoMenu(produto) {

        let indexBX = this.branded.Blendeds[this.indexBL].Produtos.indexOf(produto);
        let object = {etapa: 2, branded: this.branded, indexBL: this.indexBL, indexBX: indexBX};
        this.navCtrl.push(BlendedMenuPage, object);

    }

    produtoShet() {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Nome',    handler: () => this.moduledText('ProdutoNome', TFieldType.ftLine)});
        buttons.push({text: 'Package', handler: () => this.packageMenu()});
        this.util.sheetOpen(buttons, 'SETTING');

    }

    produtoIcon() {

        let tipo = this.branded.Blendeds[this.indexBL].Produtos[this.indexBX].ProdutoTipo;

        if (tipo == TProdutoTipo.ptNone) return 'b-icon-tools';
        if (tipo == TProdutoTipo.ptDoor) return 'b-icon-ticket';
        if (tipo == TProdutoTipo.ptCard) return 'b-icon-certificate';
        if (tipo == TProdutoTipo.ptSeal) return 'b-icon-certificate';

        return '';

    }

    produtoTipo() {

        let onSave = (tipo) => {
            this.branded.Blendeds[this.indexBL].Produtos[this.indexBX].ProdutoTipo = tipo;
            this.produtoSave(null);
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TProdutoTipo);
        let buttons: Array<any> = [];
        arrayEnum.forEach(tipo => buttons.push({text: tipo.slice(2, 99), handler: () => onSave(TProdutoTipo[tipo])}));
        this.util.sheetOpen(buttons, 'TIPO');

    }

    produtoAuth() {

        let onSave = (auth) => {
            this.branded.Blendeds[this.indexBL].Produtos[this.indexBX].ProdutoAuth = auth;
            this.produtoSave(null);
        };

        /** OPEN **/
        let cardseal = TProdutoTipo[this.boxroot.ProdutoTipo].slice(2, 99).toUpperCase();
        let arrayEnum = this.util.enumArray(TProdutoAuth);
        let buttons: Array<any> = [];
        arrayEnum.forEach(auth => buttons.push({text: auth.slice(2, 99), handler: () => onSave(TProdutoAuth[auth])}));
        this.util.sheetOpen(buttons, cardseal + ' AUTH');

    }

    produtoGtin() {

        let onOkey = (okey, that, data) => {

            this.branded.Blendeds[this.indexBL].Produtos[this.indexBX].ProdutoGtin = okey.inputf.text;
            this.produtoSave(that);

        };

        let data = {name: 'GTIN', mask: '0000000000000', size: 13};
        let objectData = {modalinfo: this.config.modalinfo(this.util, 'fiscal', onOkey, null, false, data)};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    produtoSize() {

        let onSave = (unid) => {
            this.branded.Blendeds[this.indexBL].Produtos[this.indexBX].ProdutoUnid = unid;
            this.produtoSave(null);
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TProductUnid);
        let buttons: Array<any> = [];
        arrayEnum.forEach(unid => buttons.push({text: unid.slice(2, 99), handler: () => onSave(TProductUnid[unid])}));
        this.util.sheetOpen(buttons, 'SIZE CALC');

    }

    produtoSave(that, send?) {

        //Criando novo registro...
        if (!this.boxroot.ProdutoID && !send) {
            if (that) that.dismiss();
            return;
        }

/*
        //Criando ou Editando...
        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.produto(TAction.acSave, this.boxroot.ProdutoID, TBlendedTipo.btNone, this.boxroot)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (!this.boxroot.ProdutoID) this.boxroot.ProdutoID = data.Codigo;
                    if (that) that.dismiss(this.boxroot);

                },
                erro => this.util.alertResult(erro)
            );
*/
    }

    packageMenu() {

    }

    dismiss(data?) {

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(data);
            return;
        }

        this.navCtrl.pop();

    }
}



// WEBPACK FOOTER //
// ./src/pages/sync/blended-menu/blended-menu.ts